import { useEffect } from 'react';
import { useState } from 'react';
import useKeyPress from './Hooks/useKeyPress';
import { IoCartOutline } from 'react-icons/io5';
import { useAuth } from '../../Providers/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Providers/CartProvider';
import { CapitalizeFirstLowercaseRest } from '../../Helpers/CustomConverter';
import { useOffers } from '../../Providers/OffersProvider';
import useCommonFunctions from '../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions';
import { useShop } from '../../Providers/ShopProvider';
import useGetProductImage from '../../Hooks/useGetProductImage';

import './SearchBoxList.css'

const ListItemKeyWords = ({ item, active, setSelected, setHovered, setIsFocus }) => {
  const navigate = useNavigate()
  return (<div
    className={`col searchBox-result ${active ? "active" : ""}`}
    onClick={() => {
      setSelected(item);

      const params = new URLSearchParams(window.location.search)
      if (item) {
        params.set('q', item.value)
      } else {
        params.delete('q')
      }
      navigate(`/shop?${params.toString()}`)

      setIsFocus(false);
    }}
    onMouseEnter={() => setHovered(item)}
    onMouseLeave={() => setHovered(undefined)}
  >
    {CapitalizeFirstLowercaseRest(item.value)}
  </div>)
}


const ProductsCategories = ({ category, query, setIsFocus, handleCategoryClick }) => {
  return (
    <div className='col searchBox-result' onClick={() => handleCategoryClick(category, query, setIsFocus)}>
      {category.catDescription}
    </div>
  )
}

const ListItemBrand = ({ supplier, setIsFocus, query, handleSupplierClick }) => {
  return (<div className='col searchBox-result' onClick={() => handleSupplierClick(supplier, query, setIsFocus)}>
    <span>{supplier.supplierName}</span>
  </div>)
}

const SearchBoxList = ({ items, products, productsRelatesSuppliers, setIsFocus, handleKeyPress, query, productsCategories }) => {
  const { wholesalePrices } = useAuth()
  const [selected, setSelected] = useState(undefined);
  const downPress = useKeyPress("ArrowDown");
  const upPress = useKeyPress("ArrowUp");
  const enterPress = useKeyPress("Enter");
  const [cursor, setCursor] = useState(0);
  const [hovered, setHovered] = useState(undefined);
  const { addProductToBasket } = useCart()
  const { savedOfferId } = useOffers()
  const { handleCategoryClick, handleSupplierClick, handleProductInQueryClick } = useCommonFunctions()
  const { productsFilter } = useShop()
  const { GetProductImage } = useGetProductImage()

  useEffect(() => {
    if (items.length && downPress) {
      setCursor((prevState) =>
        prevState < items.length - 1 ? prevState + 1 : prevState
      );
    }
  }, [downPress]);
  useEffect(() => {
    if (items.length && upPress) {
      setCursor((prevState) => (prevState > 0 ? prevState - 1 : prevState));
    }
  }, [upPress]);
  useEffect(() => {
    if (items.length && enterPress) {
      if (items[cursor].type == 'keyWord') {
        setIsFocus(false);
      }
      setSelected(items[cursor]);
    }
  }, [cursor, enterPress]);
  useEffect(() => {
    if (items.length && hovered) {
      setCursor(items.indexOf(hovered));
    }
  }, [hovered]);

  var allArticleButtonStyle = productsFilter.AllArticles ? 'col results-product-button-selected' : 'col results-product-button'

  return (
    <div className='row results-searching'>
      <div className='col-12 col-lg-2 results-leftSide'>
        <div className='results-kewords'>Grupa towarowa</div>
        {items.map((item, index) => {
          return <div className='row'>
            <div className=''>
              <div className='row'>

                {(item.type == "NoResults") && <div >{item.value}</div>}
                {(item.type == 'keyWord') &&
                  <ListItemKeyWords
                    key={index}
                    active={index == cursor}
                    item={item}
                    setSelected={setSelected}
                    setHovered={setHovered}
                    setIsFocus={setIsFocus}
                  />}
              </div>
            </div>
          </div>
        })}
        <div className='results-kewords'>
          Kategorie
        </div>
        {productsCategories.length > 0 && productsCategories.map((c, key) => (
          <div className="row">
            <ProductsCategories
              key={key}
              category={c}
              query={query}
              setIsFocus={setIsFocus}
              handleCategoryClick={handleCategoryClick}
            />
          </div>
        ))}
      </div>
      <div className='col results-products '>
        {products && products.map(product => {
          const priceNet = wholesalePrices ? product.priceNet : product.priceNetBase
          const priceGross = wholesalePrices ? product.priceGross : product.priceGrossBase

          return <div className='row p-1 align-items-center results-product'
            onClick={() => handleProductInQueryClick(product.index, setIsFocus)}>
            <div className='col-auto'>
              <GetProductImage
                photoFileName={product.photoFileNames[0]}
                imgClassName='results-product-img'
              />
            </div>
            <div className='col-5'>
              <div className='row results-product-title'>
                {CapitalizeFirstLowercaseRest(product.title)}
              </div>
              <div className='row results-product-label'>
                {CapitalizeFirstLowercaseRest(product.label)}
              </div>
            </div>
            <div className='col '>
              <div className='row'>
                <div className='col results-product-price'>
                  {priceNet.toLocaleString(undefined, { minimumFractionDigits: 2 })} {product.currency}
                </div>
              </div>
              <div className='row align'>
                <div className='col-auto'>
                  {priceGross.toLocaleString(undefined, { minimumFractionDigits: 2 })} {product.currency}
                </div>
                <div className='col-auto text-gray'>{product.taxRate}%</div>
                <div className='col-auto'>
                  {savedOfferId == -1 && <IoCartOutline size={30} color='var(--primary)' onClick={(e) => {
                    e.stopPropagation() // Blokuje wywołanie onClick z rodzica                    
                    addProductToBasket(product.index, product.salesRatio)
                  }
                  } />}
                </div>
              </div>
            </div>
          </div>
        })}

        <div className="row">
          <div className={allArticleButtonStyle}>
            <button onClick={() => handleKeyPress(null, true, productsRelatesSuppliers)}>Dodaj bazę produktów na zamówienie</button>
          </div>

        </div>
      </div>
      <div className='col-2 mt-4 ms-4'>
        <div className={`${productsRelatesSuppliers.length === 0 ? 'collapse' : ''} results-kewords`}>Producenci</div>
        {productsRelatesSuppliers.length > 0 && productsRelatesSuppliers.map((supplier, index) => {
          return <div className='row'>
            <ListItemBrand
              key={index}
              supplier={supplier}
              setIsFocus={setIsFocus}
              query={query}
              handleSupplierClick={handleSupplierClick}
            />
          </div>
        })}
      </div>
    </div>

  )
}

export default SearchBoxList